import styled from "styled-components";

export const Body = styled.div`
  width: 100%;
  height: 1150px;

  background: #121214;
`;
